import { createFileRoute } from '@tanstack/react-router'

import SwadayaPage from '@/components/pages/backoffice/_ktg-penyuluh/swadaya/containers/SwadayaPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/swadaya/')({
  component: SwadayaPage
})
